import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Misc } from "app/models/core/keys";
import { ILicenseCashReport } from "app/models/core/reports/licenseCashReport";
import { SharedService } from "app/services/core/shared.service";
import { ReportsService } from "app/services/reports/reports.service";


@Component({
  selector: 'app-licenseCashReports',
  templateUrl: './licenseCashReports.component.html',
  styleUrls: ['./licenseCashReports.component.scss'],
})

export class LicenseCashReportsComponent implements OnInit {

  months = Misc.months;
  years = Misc.years;
  mon = 0;
  yr = 0;
  date = '';

  licenseCashData: ILicenseCashReport[] = [];

  reportMode = 'none';

  reportGroup = new UntypedFormGroup({
    Month: new UntypedFormControl(''),
    Year: new UntypedFormControl(''),
  });

  displayedColumns: string[] = ['stateNumber', 'cliaNumber', 'labName', 'labTypeName', 'licensedDate',
    'cashDate', 'crNumber', 'amountPaid', 'credit'
  ];
  displayedColumns2: string[] = ['stateNumber', 'cliaNumber', 'labName', 'expirationDate', 'siteCity',
    'amountPending'
  ];  
  displayedColumns3: string[] = ['stateNumber', 'cliaNumber', 'labName', 'expirationDate', 'siteCity',
    'amount pending'
  ];  
  
  
  dataSource = new MatTableDataSource<ILicenseCashReport>(this.licenseCashData);
  @ViewChild('TableSort') sort: MatSort;



  constructor(public reportsService: ReportsService,
    public sharedService: SharedService) { };

  ngOnInit(): void {

    this.reportsService.currentTab = 0;

    let now = new Date()
    this.reportGroup.controls['Month'].setValue((now.getMonth() + 1).toString());
    this.reportGroup.controls['Year'].setValue(now.getFullYear().toString());
  }

  licenseCashReport() {
    this.mon = this.reportGroup.controls['Month'].value;
    this.yr = this.reportGroup.controls['Year'].value;
    this.reportsService.getLicenseCashReportData(this.mon.toString(), this.yr.toString()).subscribe(
      res => {
        this.licenseCashData = res;
        this.dataSource.data = this.licenseCashData;
        this.dataSource.sort = this.sort;

        this.reportMode = 'licenseCash';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  hstReport() {
    this.reportsService.getHstNonRenewalReport().subscribe(
      res => {
        this.licenseCashData = res;
        this.dataSource.data = this.licenseCashData;
        this.dataSource.sort = this.sort;
        this.date = this.licenseCashData != null && this.licenseCashData.length > 0 ? 
            this.licenseCashData[0].hstNonRenewalReportDate : '';
        this.reportMode = 'hst';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  soaReport() {
    this.reportsService.licenseCashSoaNonRenewalReport().subscribe(
      res => {
        this.licenseCashData = res;
        this.dataSource.data = this.licenseCashData;
        this.dataSource.sort = this.sort;
        this.date = this.licenseCashData != null && this.licenseCashData.length > 0 ? 
            this.licenseCashData[0].soaNonRenewalReportDate : '';

        this.reportMode = 'soa';
      },
      error => console.log('error', error),
      () => {
      }
    );
  }

  csv(mode: string) {
    let fileName = 'LicenseCash.csv';
    if (mode == 'hst') {
      fileName = 'HST.csv';
    }
    else if (mode == 'soa') {
      fileName = 'SOA.csv';
    }
    this.sharedService.exportToCsv(fileName, this.licenseCashData);
  }

  pdf(mode: string) {
    if (mode == 'licenseCash') {
      this.reportsService.getLicenseCashReport(this.licenseCashData).subscribe(
        response => this.downloadFile("LicenseCash", response),
        error => console.log('error', error)
      );
    }
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  tabVisible(type: string): boolean {
    // TODO
    return true;
  }

}
